import { useRef } from 'react';
import { Box, Typography } from '@mui/material';
import CustomLink from '../shared/custom/custom-link';
import { Rutas } from '@/constants/rutas';
import { getPostCardImage } from '@/helpers/images-helper';
import { useImageHeight } from '@/DesignSystem/hooks/useImageHeight';
import CustomImageComponent from '../shared/custom/custom-image';

export const NoticiasPostContentRow = ({ cover, title, slug, url, isPrimary, webkitLineClamp = 2 }) => {
    const containerRef = useRef(null);
    const imageHeight = useImageHeight(150); // Forzar a 150 para mantener cuadrado
    const image =
        cover?.length > 10
            ? getPostCardImage(cover, 150, imageHeight)
            : 'https://assets.analiticafantasy.com/2024/secciones/alineaciones-probables.jpg';
    const linkHref = url?.length > 1 ? url : `${Rutas.NOTICIAS}/${slug}`;

    const width = 160 * 0.6;
    const height = 90 * 0.6;

    return (
        <CustomLink href={linkHref}>
            <Box
                ref={containerRef}
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 2,
                    py: 1,
                    backgroundColor: 'background.darkCard',
                    border: '1px solid',
                    borderColor: 'border.main',
                    borderRadius: 1,
                    transition: 'all 0.3s ease',
                    '&:hover': {
                        transform: 'translateY(-2px)',
                    },
                    cursor: 'pointer',
                    paddingRight: 1,
                }}
            >
                <Box
                    sx={{
                        width: width,
                        height: height,
                        flexShrink: 0,
                        borderRadius: '4px',
                        overflow: 'hidden',
                    }}
                >
                    <CustomImageComponent
                        src={image}
                        alt="Imagen de la noticia"
                        priority={isPrimary}
                        width={width}
                        height={height}
                    />
                </Box>
                <Typography
                    sx={{
                        fontSize: '14px',
                        fontWeight: 400,
                        lineHeight: 1.4,
                        display: '-webkit-box',
                        WebkitLineClamp: 2,
                        WebkitBoxOrient: 'vertical',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        flex: 1, // Ocupar todo el ancho restante
                    }}
                >
                    {title}
                </Typography>
            </Box>
        </CustomLink>
    );
};

export default NoticiasPostContentRow;
